import { Box, Modal, Typography } from '@mui/material';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useApiError from 'packages/novous_web/src/api/useApiError';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import Button from 'packages/novous_web/src/common/components/Button';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import React, { useState } from 'react'

interface DeviceHealthReport {
    attachments: string[];
    category: string;
    createdAt: string;
    createdByCategoryStatus: string;
    createdByDocumentType: string;
    createdByDocumentTypeStatus: string;
    createdByStatus: string;
    department: string;
    docIdNumber: string;
    documentType: string;
    documentUniqueId: string;
    entityId: string;
    expiryDate: string;
    fleetId: string;
    notes: string;
    sortKey: string;
    status: string;
    updatedAt: string;
}

const data: DeviceHealthReport[] = []

interface DeleteDataProps {
    isDeleteModalOpen: boolean;
    handleDeleteModalClose: () => void;
    onDocumentSaved?: () => void;
    handleDeleteDocument?: DeviceHealthReport | null;
    heading?: string;
    message?: string;
}

const DeleteDocumentData: React.FC<DeleteDataProps> = ({
    isDeleteModalOpen,
    handleDeleteModalClose,
    handleDeleteDocument,
    onDocumentSaved,
    heading,
    message
}) => {
    const [toast, setToast] = useState({ open: false, message: '', type: 'error' });
    const [isDeleteingData, setIsDeletingData] = useState<boolean>(false);
    const {
        data: DocumentDeleteData,
        error: DocumentDeleteDataError,
        loading: DocumentDeleteDataLoading,
        fetchData: fetchDocumentDeleteDataData,
    } = useApiError<any>(`${API_ENDPOINTS.documents.DOCUMENT_DELETE}`, "DELETE");

    const handelDelete = async () => {
        setIsDeletingData(true);
        try {
            const response = await fetchDocumentDeleteDataData(
                undefined,
                {
                    params: {
                        documentUniqueId: handleDeleteDocument?.documentUniqueId,
                    },
                }
            );
            if (response) {
                setToast({ open: true, message: response, type: 'success' });
                setIsDeletingData(false);
                handleDeleteModalClose();
            } else {
                setToast({ open: true, message: response, type: 'error' });
                setIsDeletingData(false);
            }
            if (onDocumentSaved) {
                onDocumentSaved();
            }
        } catch (error) {
            console.error("Error sending email:", error);
            setToast({ open: true, message: (error as Error).message, type: 'error' });
            setIsDeletingData(false);
        } finally {
            setIsDeletingData(false);
        }
    }
    return (
        <>
            <Modal
                open={isDeleteModalOpen}
                onClose={handleDeleteModalClose}
                aria-labelledby="download-modal-title"
                aria-describedby="download-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '480px',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 4,
                    }}
                >
                    <div className="flex flex-col">
                        <Typography variant="h6" sx={{ color: (theme) => theme.palette.text.primary }}>
                            {heading}
                        </Typography>
                        <Typography variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
                            {message}
                        </Typography>
                        <div className="flex justify-between mt-6">
                            <CustomIconButton
                                text="Back"
                                background="transparent"
                                outline={true}
                                padding="0px"
                                variant="outlined"
                                onClick={handleDeleteModalClose}
                            />
                            <Button
                                text={isDeleteingData ? "Deleting..." : "Delete"}
                                onClick={handelDelete}
                                fullWidth={false}
                            />
                        </div>
                    </div>
                </Box>
            </Modal>
            <AlertToast
                open={toast.open}
                message={toast.message}
                onClose={() => setToast((prev) => ({ ...prev, open: false }))}
                type={toast.type as any}
            />
        </>
    )
}

export default DeleteDocumentData